import React from 'react';
import PetIcon from './PetIcon';

const getGenderBg = (gender) => {
  if (!gender) return 'bg-gray-200 ring-2 ring-gray-300';
  const g = gender.toLowerCase();
  if (g === 'erkek' || g === 'male' || g === 'e') return 'bg-blue-200 ring-2 ring-blue-300';
  if (g === 'dişi' || g === 'disi' || g === 'female' || g === 'd') return 'bg-pink-200 ring-2 ring-pink-300';
  return 'bg-gray-200 ring-2 ring-gray-300';
};

const PetAvatar = ({ species, gender, size = 20, className = '' }) => {
  const outerSize = Math.round(size * 1.8);
  return (
    <div
      className={`rounded-full flex items-center justify-center flex-shrink-0 ${getGenderBg(gender)} ${className}`}
      style={{ width: outerSize, height: outerSize }}
    >
      <PetIcon species={species} size={size} />
    </div>
  );
};

export default PetAvatar;
